<template>
  <div ref="listRef" class="template-wrapper" @scroll="onScroll">
    <div class="w-full">
      <div
        class="sticky header top-0 z-[11] bg-back-bg pt-[39px] px-[60px] filter-box"
      >
        <Resource
          v-if="getEnv('area') === 'CN'"
          :src="headerBgUrl"
          :transform-resource="transformImage"
          class="absolute left-0 top-0 w-full"
          :lazy="false"
          fetchPriority="hight"
        />
        <div class="page-container">
          <!-- <div>
            <Search
              ref="searchRef"
              v-model="keyword"
              size="large"
              class="w-[800px] mx-auto mb-[48px]"
              :placeholder="$t('sou-suo-yong-hu-zuo-pin')"
              :showHot="true"
              :area="SEARCH_RECORD_UNIQUE.TEMPLATE"
              @search="handleOnSearch"
            >
            </Search>
          </div> -->
          <div class="tag-list" :class="{ small: tagsIsSmall }">
            <Tags
              v-for="h in centerTags.tags.filter((v) =>
                enableGroups.includes(v.outer_id!)
              )"
              :key="h.tag_id"
              v-model="searchFrom[`tag_${h.tag_id}`]"
              :data="h"
              :multiple="
                h.outer_id !== TagKey.INDUSTRY && h.outer_id !== TagKey.LANGUAGE
              "
            />
          </div>
          <div class="w-full h-[1px] bg-back-3 mb-[19px]"></div>
          <div class="w-full flex-y-center pb-[5px]">
            <DictFilter
              v-model="searchFrom.sort"
              name="sorts"
              :has-all="false"
              class="text-14 gap-x-[20px]"
            />
            <div class="justify-end flex-1 flex-y-center">
              <div class="flex-y-center">
                <span class="dict-name line">{{ $t('ban-shi') }}</span>
                <DictFilter
                  v-model="searchFrom.format"
                  name="formats"
                  class="format text-14 gap-x-[20px]"
                  @change="onChangeFormat"
                />
              </div>
              <div class="flex-y-center ml-[30px]">
                <span class="dict-name -mr-[15px]">{{
                  $t('yan-bo-shi-lei-xing')
                }}</span>
                <a-select
                  v-model:value="searchFrom.map_types"
                  :placeholder="$t('qing-xuan-ze')"
                  size="small"
                  class="w-[120px] dict-select"
                  allow-clear
                  :dropdown-match-select-width="false"
                  :options="studioListFilter"
                  @change="onChangeStudio"
                >
                  <template #suffixIcon>
                    <iconpark-icon name="arrowdown" class="opacity-30" />
                  </template>
                </a-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page-container">
        <a-alert
          v-if="sceneTip"
          :message="sceneTip"
          type="info"
          show-icon
          closable
          :after-close="onCloseEnd"
        />

        <div class="py-[15px]">
          <TemplateMasonry
            v-if="calList.length"
            :list="calList"
            class="gap-y-[0px]"
            :template_source="TEMPLATE_SOURCE.TEMPLATE_PAGE"
          />
          <Empty
            v-else-if="(!pending && !first) || !list.length"
            :list="popularList?.data"
            @refresh="popularRefresh"
            @select="handleOnSearch"
          />
          <Divider v-if="list.length === total && total >= 15" />
        </div>
        <div
          v-if="pending"
          :class="{
            'fixed h-[calc(100%-90px)]': current === 1,
          }"
          class="w-full flex-center mt-[20px] bottom-0 left-0 z-8 bg-back-1 bg-opacity-60"
        >
          <a-spin />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { debounce } from 'lodash-es'
import Tags from './components/tags.vue'
import TemplateMasonry from '~/components/templates/index.vue'
import { getStudioList, getTemplate, getTemplateSearch } from '~/api'
import { type TemplateParams } from '~/api/interface'
import { TEMPLATE_SOURCE } from '~/utils/track'
import { TagKey, TEMPLATE_SORT, SEARCH_RECORD_UNIQUE } from '~/constants/index'
import { useScrollList, SCROLL_LIST } from '~/hooks/useScrollList'
import { useTemplateDetail } from '~/hooks/useModal/modals/template'
import { useStarPatchList } from '~/hooks/useStarPatch'
import { useMountedWatch } from '~/hooks/useMountedWatch'
import Search from '@/features/searchInput/index.vue'
import Empty from '@/features/searchInput/empty.vue'
import { getTemplateHotWord } from '~/api/module/search'

const route = useRoute()

const searchFrom = reactive<any>({
  sort: TEMPLATE_SORT.ALL,
  format: '',
  map_types: route.query.map_types || undefined,
})
const centerTags = useCenterTags()
const listRef = ref()
const sceneTip = ref('')
const KEYNAME = 'youyan-studio-keys'
const tagsIsSmall = ref(false)
const { $t } = useNuxtApp()
const shareVisible = useShare()
const keyword = ref()

const enableGroups = ['industry', 'language', 'template_application_scene']

const { data: popularList, refresh: popularRefresh } = useAsyncData(() =>
  getTemplateHotWord(8)
)

const headerBgUrl = getFeUrl(
  isChinese()
    ? '/youyan-platform/png/template-bg.png'
    : '/youyan-platform/png/template-en-bg.png'
)

const getTagIds = () => {
  const tagIds: string[] = []

  centerTags.value.tags.forEach((h) => {
    const tags = searchFrom[`tag_${h.tag_id}`]

    if (!tags?.length) {
      return
    }

    if (tags[0].tag_id === h.tag_id) {
      return
    }

    tags.forEach((t: any) => {
      tagIds.push(t.ids)
    })
  })
  const ids = tagIds.join('_')
  if (ids.length > 0) {
    history.replaceState({}, '', `/template?tag_ids=${ids}`)
  }
  return ids
}

const { data: studioList } = useAsyncData(async () => {
  const res = await getStudioList()

  return (
    res?.data?.map(
      (item: { resolutions: any; message: any; name: any; id: any }) => ({
        value: String(item.id),
        label: item.name,
        message: item.message,
        resolutions: item.resolutions,
      })
    ) || []
  )
})

const studioListFilter = computed(() => {
  return studioList.value?.filter((x) => {
    const l = x.resolutions
    if ((searchFrom.format || 'all') === 'all' || !l || l.length === 0) {
      return true
    }

    return l.includes(searchFrom.format)
  })
})

provideResourceLocation({
  source: SOURCE.TEMPLATE_CENTER,
})

const { list, pending, refresh, next, total, current, clear } = useScrollList(
  async (params) => {
    const p: TemplateParams = {
      ...params,
      tag_ids: getTagIds(),
      o: searchFrom.sort,
      is_template_center_template: 1,
      map_types: searchFrom.map_types,
      resolution:
        (searchFrom.format || 'all') !== 'all' ? searchFrom.format : undefined,
      platform: 0,
      online_status: 0,
      query_star: import.meta.client,
      q: keyword.value,
    }

    // const res = await getTemplateList(p)
    const res = await getTemplateSearch(p)

    res.data?.results?.forEach((item) => {
      item.query_star = import.meta.client // 标记这些数据是否查询过star
    })

    return res
  },
  {
    key: SCROLL_LIST.TEMPLATE_LIST,
  }
)

const { calList, status } = useStarPatchList(list, 3)

let first = true

const handleOnSearch = (val: string) => {
  keyword.value = val
  refresh()
}

useMountedWatch([calList, status], async () => {
  if (first && route.query.id && status.value === 'success') {
    first = false
    const index =
      list.value.findIndex((record) => record.id === Number(route.query.id)) ||
      -1
    if (index > -1) {
      setTimeout(() => {
        listRef.value
          .querySelector(`.card-item:nth-child(${index + 1})`)
          ?.click()
      }, 100)
    } else {
      const details = await getTemplate({
        template_id: Number(route.query.id),
      })
      useTemplateDetail(
        [details.data!],
        details.data!,
        {
          templateSource: TEMPLATE_SOURCE.TEMPLATE_PAGE,
          source: SOURCE.TEMPLATE_CENTER,
        },
        undefined
      )
    }
  }
})

onBeforeUnmount(() => {
  clear()
})

useBackToTop(() => ({
  scrollContainer: '.template-wrapper',
  item: '.card-item',
  total: total.value,
}))

onMounted(() => {
  const { tag_ids } = route.query
  if (tag_ids) {
    const links = String(tag_ids).split('_')
    const tagMap = useTagMap()

    links.forEach((l) => {
      const [_, rootType] = l.split(':')[0]?.split(',')
      if (!searchFrom[`tag_${rootType}`]) {
        searchFrom[`tag_${rootType}`] = []
      }
      const tagItem = tagMap.value[l]
      if (tagItem) {
        if (tagItem.children && tagItem.children.length) {
          searchFrom[`tag_${rootType}`].push(...tagItem.children)
        } else {
          searchFrom[`tag_${rootType}`].push(tagItem)
        }
      }
    })
  }
})

const onScroll = (e: any) => {
  const { scrollTop, scrollHeight, clientHeight } = e.target as HTMLBRElement
  if (scrollTop > 200 && !tagsIsSmall.value) {
    tagsIsSmall.value = true
  } else if (scrollTop <= 1 && tagsIsSmall.value) {
    tagsIsSmall.value = false
  }

  if (Math.round(scrollTop + clientHeight) >= scrollHeight - 1) {
    next()
  }

  if (!shareVisible.value) {
    return
  }

  shareVisible.value = false
}

const onChangeStudio: any = (v: string, d: any) => {
  const keys = JSON.parse(localStorage.getItem(KEYNAME) || '{}')
  sceneTip.value = ''
  if (v && !keys[v] && d.message) {
    sceneTip.value = `${d.label}：“${d.message}”`
  }
}

const onCloseEnd = () => {
  sceneTip.value = ''
  const keys = JSON.parse(localStorage.getItem(KEYNAME) || '{}')
  localStorage.setItem(
    KEYNAME,
    JSON.stringify({ ...keys, [searchFrom.map_types]: true })
  )
}
const onChangeFormat = () => {
  searchFrom.map_types = undefined
  sceneTip.value = ''
}
watch(
  searchFrom,
  debounce(() => {
    if (listRef.value) {
      listRef.value.scrollTop = 0
    }

    refresh()
  }, 500)
)

watch(
  () => searchFrom.format,
  (val) => {
    trackEvent(TRACK_EVENT.CLICK_TEMPLATE_FORMAT_FILTER, {
      filter: val,
      source: SOURCE.TEMPLATE_CENTER,
    })
  }
)

watch(
  () => searchFrom.map_types,
  (val) => {
    trackEvent(TRACK_EVENT.CLICK_TEMPLATE_CENTER_STUDIO_FILTER, {
      map_types: val,
      source: SOURCE.TEMPLATE_CENTER,
    })
  }
)

watch(
  () => searchFrom.sort,
  (val) => {
    trackEvent(TRACK_EVENT.CLICK_TEMPLATE_CENTER_SORT_FILTER, {
      sort: val,
      source: SOURCE.TEMPLATE_CENTER,
    })
  }
)
</script>

<style scoped lang="scss">
.sorts {
  @apply font-semibold;
}

.dict-name {
  @apply text-14 flex-y-center;

  &:after {
    @apply ml-[10px] mr-[20px] w-[1px] h-[12px] block;
    content: '';
  }

  &.line:after {
    @apply bg-back-6;
  }
}

.tag-list {
  @apply w-full flex gap-[20px] flex-wrap mb-[20px] flex-col;
  &.small {
    @apply flex-row;
    :deep(.dict-item) {
      display: none;
      &.active {
        display: flex;
      }
    }
  }
}
.filter-box {
  &:hover {
    .tag-list.small {
      @apply flex-col;
      :deep(.dict-item) {
        display: flex;
      }
    }
  }
}

.template-wrapper {
  @apply flex flex-col overflow-y-scroll relative w-full;
  height: calc(100vh - 56px);

  .header {
    // background-image: v-bind('headerBg');
    // background-repeat: no-repeat;
    background-color: var(--back-bg);
    // background-size: 100% 80px;
  }
  .page-container {
    width: rem(1200);
    min-width: 1200px;
    margin: 0 auto;
  }
}

.dict-select {
  :deep(.ant-select-selector) {
    height: 28px !important;
    border-radius: 6px;
    .ant-select-selection-placeholder {
      line-height: 25px;
      color: var(--text-1-40);
    }
    .ant-select-selection-item {
      line-height: 25px;
    }
  }
}
</style>
